(function (window, document, undefined) {


  window.sectionCartDefaultTimeout = 1000;

  window.sectionCart = {


    refresh: (timeout) => {

      function get_section() {
        document.querySelector('.s_cart_w').classList.add('loading-state');

        fetch(`/cart?sections=main-cart-content`)
        .then((response) => response.json())
        .then((data) => {
          let container = document.querySelector('.s_cart_w');
          if (container) {
            container.innerHTML = data['main-cart-content'];
          } 
          window.sectionCart.init();
          window.pGiftWrap.init();
          window.pShipping.init();
          document.querySelector('.s_cart_w').classList.remove('loading-state');

          let items_number = container.querySelector('[data-cart-items-number]');
          if (items_number) {
            let items_number_value = items_number.getAttribute('data-cart-items-number'),
                cart_counter = document.querySelector('cart-counter');
            if (cart_counter && items_number_value != null) {
              cart_counter.set(items_number_value);
            }
          }
        });
      }

      if (window.sectionCartTimer) {
        clearTimeout(window.sectionCartTimer);
      }

      if (timeout) {
        window.sectionCartTimer = setTimeout(() => {
          get_section();
        }, timeout);
      } else {
        get_section();
      }

    },


    addListeners: () => {

      let qty_input = document.querySelectorAll('.qtybox__input'),
          qty_minus = document.querySelectorAll('.qtybox__minus'),
          qty_plus = document.querySelectorAll('.qtybox__plus'),
          remove = document.querySelectorAll('.removebox'),
          gift_wrap_checkboxes = document.querySelectorAll('[name^="gift_wrap_checkbox_"]'),
          note = document.querySelector('.s_cart [name="note"]'),
          invoice = document.querySelector('.s_cart [name="attributes[invoice]"]');

      
      function check_input(e, index, type) {
        let name = 'sectionCartInput' + index;

        if (window[name]) {
          clearTimeout(window[name]);
        }

        window[name] = setTimeout(() => {
          let product = e.target.closest('[data-product-id]'),
              product_id = parseFloat(product.getAttribute('data-product-id'));

          let data = {updates: {}};
          data.updates[product_id] = parseFloat(e.target.closest('.qtybox').querySelector('.qtybox__input input').value); 

          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
          }).then(() => {
            window.sectionCart.refresh();
          });
        }, 1000);
      }

      if (qty_input.length) {
        qty_input.forEach((e, index) => {
          e.addEventListener('keyup', (e) => {
            check_input(e, index, 'keyup');
          });

          e.addEventListener('paste', (e) => {
            check_input(e, index, 'paste');
          });
        });
      }

      if (qty_minus.length) {
        qty_minus.forEach((e)=> {
          e.addEventListener('click', () => {

            if (window.sectionCartMinusTimer) {
              clearTimeout(window.sectionCartMinusTimer);
            }

            if (window.sectionCartPlusTimer) {
              clearTimeout(window.sectionCartPlusTimer);
            }

            let input = e.closest('.qtybox').querySelector('.qtybox__input input'),
                v = parseFloat(input.value);

            if (v > 1) {
              input.value = v - 1;
            }

            window.sectionCartMinusTimer = setTimeout(()=>{
              let product = e.closest('[data-product-id]'),
                  product_id = parseFloat(product.getAttribute('data-product-id'));

              let data = {updates: {}};
              data.updates[product_id] = parseFloat(e.closest('.qtybox').querySelector('.qtybox__input input').value); 

              fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
              }).then(() => {
                window.sectionCart.refresh();
              });
            }, 500);

          });
        });
      }

      if (qty_plus.length) {
        qty_plus.forEach((e)=> {
          e.addEventListener('click', () => {

            if (window.sectionCartMinusTimer) {
              clearTimeout(window.sectionCartMinusTimer);
            }

            if (window.sectionCartPlusTimer) {
              clearTimeout(window.sectionCartPlusTimer);
            }

            let input = e.closest('.qtybox').querySelector('.qtybox__input input'),
                v = parseFloat(input.value);

            if (v != '') {
              input.value = v + 1;
            }

            window.sectionCartPlusTimer = setTimeout(()=>{
              let product = e.closest('[data-product-id]'),
                  product_id = parseFloat(product.getAttribute('data-product-id'));

              let data = {updates: {}};
              data.updates[product_id] = parseFloat(e.closest('.qtybox').querySelector('.qtybox__input input').value); 

              fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
              }).then(() => {
                window.sectionCart.refresh();
              });
            }, 500);

          });
        });
      }

      if (remove.length) {
        remove.forEach((e)=> {
          e.addEventListener('click', () => {

            let product = e.closest('[data-product-id]'),
                product_id = parseFloat(product.getAttribute('data-product-id'));

            let data = {updates: {}};
            data.updates[product_id] = 0; 

            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(data)
            }).then(() => {
              window.sectionCart.refresh();
            });

          });
        });
      }

      if (gift_wrap_checkboxes.length) {
        gift_wrap_checkboxes.forEach((e) => {
          e.addEventListener('click', () => {
            let line_item_product_key = e.getAttribute('data-line-item-product-key'),
                line_item_product_id = e.getAttribute('data-line-item-product-id'),
                gift_wrap_product_id = e.getAttribute('data-gift-wrap-product-id'),
                gift_wrap_product_title = e.getAttribute('data-gift-wrap-product-title'),
                gift_wrap_product_options = e.getAttribute('data-gift-wrap-product-options');

            if (e.checked == true) {
              window.sectionCart.addGiftWrap(line_item_product_key, gift_wrap_product_id, gift_wrap_product_title, gift_wrap_product_options);
            } else {
              window.sectionCart.removeGiftWrap(line_item_product_key, gift_wrap_product_id);
            }
          });
        });
      }

      if (note) {
        window.note_fetch = (_e) =>{
          let data = {note: _e.target.value},
              submit_btn = document.querySelector('.s_cart__summary .mbox__btn');

          if (submit_btn) {
            submit_btn.classList.add('is_loading');
          }

          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
          }).then(() => {
            if (submit_btn) {
              submit_btn.classList.remove('is_loading');
            }
          });
        };

        note.addEventListener('input', (e) => {
          let submit_btn = document.querySelector('.s_cart__summary .mbox__btn');
          
          if (submit_btn) {
            submit_btn.classList.add('is_loading');
          }

          if (window.note_timeout_fetch) {
            clearTimeout(window.note_timeout_fetch);
          }

          window.note_timeout_fetch = setTimeout(() => {
            window.note_fetch(e);
          }, 1000, e);
        });

        note.addEventListener('change', (e) => {
          window.note_fetch(e);
        });
      }

      if (invoice) {
        window.invoice_fetch = (_e) =>{
          let data = {
                attributes: {
                  invoice: _e.target.value
                }
              },
              submit_btn = document.querySelector('.s_cart__summary .mbox__btn');

          if (submit_btn) {
            submit_btn.classList.add('is_loading');
          }

          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
          }).then(() => {
            if (submit_btn) {
              submit_btn.classList.remove('is_loading');
            }
          });
        };

        invoice.addEventListener('input', (e) => {
          let submit_btn = document.querySelector('.s_cart__summary .mbox__btn');
          
          if (submit_btn) {
            submit_btn.classList.add('is_loading');
          }

          if (window.invoice_timeout_fetch) {
            clearTimeout(window.invoice_timeout_fetch);
          }

          window.invoice_timeout_fetch = setTimeout(() => {
            window.invoice_fetch(e);
          }, 1000, e);
        });

        invoice.addEventListener('change', (e) => {
          window.invoice_fetch(e);
        });
      }
    },


    addGiftWrap(line_item_product_key, gift_wrap_product_id, gift_wrap_product_title, gift_wrap_product_options) {
      document.querySelector('.s_cart_w').classList.add('loading-state');

      let data = {
        items : [
          {
            quantity: 1,
            id: parseFloat(gift_wrap_product_id),
            properties: {
              '_Wrap line item product id': line_item_product_key,
              '_Wrap product title': gift_wrap_product_title,
              '_Wrap product options': gift_wrap_product_options
            }
          }
        ]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then(() => {
        window.sectionCart.refresh();
      });
      
    },


    removeGiftWrap(line_item_product_key, gift_wrap_product_id) {
      document.querySelector('.s_cart_w').classList.add('loading-state');

      let data = {
        'id': gift_wrap_product_id,
        quantity: 0
      }

      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then(() => {
        window.sectionCart.refresh();
      });

    },


    removeUnnecessaryGiftWrapProducts() {
      let gift_wrap_products = document.querySelectorAll('.product[data-is-gift-wrap="1"]'),
          data = [];

      if (gift_wrap_products.length) {
        gift_wrap_products.forEach((e) => {
          let product_id = String(e.getAttribute('data-product-id')),
              is_gift_wrap_for = String(e.getAttribute('data-is-gift-wrap-for')),
              is_gift_without_options = e.getAttribute('data-is-gift-without-options'),
              product_quantity = parseFloat(e.getAttribute('data-product-quantity')),
              remove_product = is_gift_without_options == '1' ? true : false;

          if (!document.querySelector('.s_cart [data-is-gift-wrap="0"][data-product-id="'+is_gift_wrap_for+'"]')) {
            remove_product = true;
          }

          if (remove_product == true ) {
            let obj = {
              'id': product_id,
              'quantity': 0
            };
            data.push(obj);
          } else {
            if (product_quantity > 1) {
              let obj = {
                'id': product_id,
                'quantity': 1
              };
              data.push(obj);
            }
          }
        });
      }

      if (data.length > 0) {
        document.querySelector('.s_cart_w').classList.add('loading-state');

        Promise.all(data.map(object_data =>
          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(object_data)
          }).then(resp => resp.json())
        )).then(result => {
          window.sectionCart.refresh();
        });
      }
      
    },


    setQuantityLineItem(line_item_product_id, quantity) {
      document.querySelector('.s_cart_w').classList.add('loading-state');

      let data = {
        updates : 
        {
          [line_item_product_id] : quantity
        }
      };

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then(() => {
        window.sectionCart.refresh();
      });

    },


    init: () => {
      
      window.sectionCart.addListeners();
      window.sectionCart.removeUnnecessaryGiftWrapProducts();

    }


  }


})(window, window.document);


window.sectionCart.init();
